import { render, staticRenderFns } from "./CredenciamentoCancelarDemanda.vue?vue&type=template&id=c284b49c"
import script from "./CredenciamentoCancelarDemanda.vue?vue&type=script&lang=js"
export * from "./CredenciamentoCancelarDemanda.vue?vue&type=script&lang=js"
import style0 from "./CredenciamentoCancelarDemanda.vue?vue&type=style&index=0&id=c284b49c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports